import React from "react";

export default () => {
  return (
    <div>
      <img 
        src="https://pin.it/oCJgPSiTJ" 
        alt="FalconAlgo Trading"
        style={{ 
          width: '100%',
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'block'
        }}
      />
    </div>
  );
};